// ReactQuill 본문에 삽입하는 하이퍼링크(<a>)를 항상 "새 창"으로 열도록
// Quill 의 Link blot 을 커스터마이즈한다.
//
// 저장되는 contents HTML 의 <a> 태그에 target="_blank" rel="noopener noreferrer"
// 가 직접 포함되므로, 웹 관리자 미리보기와 모바일 앱 웹뷰 양쪽에서 동일하게
// 새 창(외부 브라우저/인앱 브라우저)으로 열린다.
//
// ReactQuill 을 쓰는 컴포넌트에서 side-effect 로 한 번 import 하면, 모듈 캐시
// 덕분에 Link blot 등록은 앱 전체에서 1회만 수행된다.
import { Quill } from 'react-quill';

const Link = Quill.import('formats/link');

class TargetBlankLink extends Link {
    static create(value) {
        const node = super.create(value);
        const href = Link.sanitize(value);
        node.setAttribute('href', href);
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
        return node;
    }
}

// 두 번째 인자 true: 기존 'formats/link' 를 덮어쓰되 경고를 출력하지 않는다
Quill.register(TargetBlankLink, true);

export default TargetBlankLink;
